export const EMPLOYER_LOAD_START = 'EMPLOYER_LOAD_START';
export const EMPLOYER_PROFILE_LOAD_SUCCESS = 'EMPLOYER_PROFILE_LOAD_SUCCESS';
export const EMPLOYER_LOAD_SUCCESS = 'EMPLOYER_LOAD_SUCCESS';
export const EMPLOYER_LOAD_FAILURE = 'EMPLOYER_LOAD_FAILURE';

export const CURRENT_EMPLOYER_PROFILE_LOAD_SUCCESS = 'CURRENT_EMPLOYER_PROFILE_LOAD_SUCCESS';

export const ADD_NEW_LOCATION = 'ADD_NEW_LOCATION';
export const LOCATIONS_LOAD_SUCCESS = 'LOCATIONS_LOAD_SUCCESS';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';
export const HIRING_HERO_METRICS_LOAD_SUCCESS = 'HIRING_HERO_METRICS_LOAD_SUCCESS';
export const EMPLOYER_VALIDATION_ERROR = 'EMPLOYER_VALIDATION_ERROR';

export const EMPLOYER_SUBSCRIPTION_LOAD_SUCCESS = 'EMPLOYER_SUBSCRIPTION_LOAD_SUCCESS';
export const CONNECTORS_LOAD_SUCCESS = 'CONNECTORS_LOAD_SUCCESS';

export const EMPLOYER_PROFILE_NOTIFICATIONS_LOAD_SUCCESS =
  'EMPLOYER_PROFILE_NOTIFICATIONS_LOAD_SUCCESS';
export const EMPLOYER_PROFILE_NOTIFICATIONS_LOAD_FAILURE =
  'EMPLOYER_PROFILE_NOTIFICATIONS_LOAD_FAILURE';
